import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'absolute',
    top: 0,
  },
  barsList: {
    overflow: 'visible !important',
  },
}));
